import { womenCompetitionCodes } from 'constants/appConstants';

export const sportUtilities = {
  /*
   * @param teamCode string  e.g. LIV for liverpool
   * @param onComplete function e.g. setState
   * @param isRecursion boolean, stops function repeating when a error occurs for a missing file.
   * @return string file path for shirt image. e.g. static/img.png
   *
   */
  getShirtImage: (teamCode: string, onComplete: (path: string) => void, isRecursion: boolean = false, competitionCode: string = '') => {
    const teamShirtCode = sportUtilities.isWomensCompetition(competitionCode) ? `${teamCode.toLowerCase()}-women` : teamCode.toLowerCase();
    import(`components/Card/assets/shirts/${teamShirtCode}.png`)
      .then((dynamicShirtImage) => {
        const path = '/' + dynamicShirtImage.default.replace(/^\/+/g, '');
        return onComplete(path);
      })
      .catch((err) => {
        console.warn(`Unable to get shirt image for "${teamCode}"`, err);
        import(`theme/assets/images/reveal.png`)
          .then((revealImage) => {
            const path = '/' + revealImage.default.replace(/^\/+/g, '');
            return onComplete(path);
          })
          .catch((err) => {
            console.warn(`Unable to load default image`, err);
            if (!isRecursion) {
              return sportUtilities.getShirtImage('error', onComplete, true);
            }
          });
      });
  },

  isWomensCompetition: (competitionCode: string): boolean => {
    return womenCompetitionCodes.includes(competitionCode);
  }
};
